<template>
  <div class="col-12 col-md-12 col-lg-6">
    <div class="tit text-center">
      <h1>Informações da empresa</h1>
      <p>Agora, por favor, confirme alguns dados sobre a sua empresa.</p>      
    </div>
    <div class="row justify-content-center">
      <div class="col-12 col-md-10 col-lg-8 col-xl-7">
         <form @submit="onSubmit">
            <div class="form-group text-left">
              <label for="nomeCompleto">CNPJ</label>
              <input class="form-control form-control-lg" v-model="Documento" type="text" required disabled v-mask="'cnpj'"/>
            </div>
            <div class="form-group text-left">
              <label>Razão Social</label>
              <input class="form-control form-control-lg" v-model="razaoSocial" type="text" required />
            </div>
            <div class="text-center fixedOptions">
              <button class="btn btn-lg btn-primary">Próximo <img src="../../assets/images/angle-right.svg"></button>             
            </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    const solicitacao = this.currentUser
    return {
      Documento: solicitacao ? solicitacao.Documento : null,   
      razaoSocial: this.verificaRazaoSocial(solicitacao),
    }
  },
  props: {
    currentUser: {required: true, type: Object}
  },
  methods: {
    verificaRazaoSocial(solicitacao) {
      if(solicitacao) {
         if(solicitacao.ReceitaWs.DadosConsulta) {

           return solicitacao.ReceitaWs.DadosConsulta.nome;

         } else if(solicitacao.HubdoDesenvolvedor.DadosConsulta) {

           return solicitacao.HubdoDesenvolvedor.DadosConsulta.result.nome;

         } else if(solicitacao.Ph3a.DadosConsulta) {

           return solicitacao.Ph3a.DadosConsulta.Razaosocial;

         } else {
           return null
         }
      } else {
        return null
      }
    },
    onSubmit(e) {
      e.preventDefault()
      
      this.currentUser.Social.RazaoSocial = this.razaoSocial
      this.currentUser.Impacto.NomeEmpresa = this.razaoSocial

    
      this.$emit('on-submit', this.currentUser)
   
    }
  },
  created() {
    if(!this.currentUser) this.currentUser = {}
  }
}
</script>


// WEBPACK FOOTER //
// src/components/AdditionalInformationSocial/InformacoesPjInstitucionalStep.vue